import { render, staticRenderFns } from "./FrequencyLine.vue?vue&type=template&id=f167dd9a&scoped=true"
import script from "./FrequencyLine.vue?vue&type=script&lang=js"
export * from "./FrequencyLine.vue?vue&type=script&lang=js"
import style0 from "./FrequencyLine.vue?vue&type=style&index=0&id=f167dd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f167dd9a",
  null
  
)

export default component.exports